import { useParams } from "react-router-dom";
import EntityEditTabs from "../../../../components/reusable-components/tabs/EntityEditTabs";
import EntitySettingsEditForm from "../../../setting/components/EntitySettingsEditForm";
import { EntityTypeLink } from "../../../setting/models/enums/EntityTypeLink";
import { EntityType } from "../../../settingDefinition/models/enums/EntityType";
import EditMenuItemForm from "../forms/EditMenuItemForm";
import ChildMenuItemsList from "../tables/ChildMenuItemsList";

const EditMenuItem = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <EntityEditTabs
      tabs={[
        {
          label: "Edit Menu Item",
          content: <EditMenuItemForm id={id} />,
        },
        {
          label: "Menu Item Settings",
          content: (
            <EntitySettingsEditForm
              entityTypeLink={EntityTypeLink.MENU_ITEMS}
              entityType={EntityType.MenuItem}
              entityId={id}
            />
          ),
        },
        {
          label: "Children Items",
          content: <ChildMenuItemsList parentId={id} />,
        },
      ]}
    />
  );
};

export default EditMenuItem;
